import { ICellRendererParams } from "ag-grid-community";
import ReactMarkdown from "react-markdown";

export const MarkdownCellRenderer = (params: ICellRendererParams) => {
	const content = params.value || "";

	return (
		<div style={{ padding: "2px 0" }}>
			<ReactMarkdown>{content}</ReactMarkdown>
		</div>
	);
};
